import * as React from 'react';

import invariant from 'invariant';

import TextWithEntities from 'components/TextWithEntities';
import Group from 'entities/Group';
// @ts-ignore
import Organization from 'entities/Organization';
import TextEntities from 'lib/TextEntities';

export type GroupPropType = { className?: string };

export type Props = {
  group: Group | Organization | GroupPropType;
};

const GroupName = ({ group }: Props) => {
  let name = null;
  if ('className' in group) {
    name = group.className;
  } else if ('getName' in group) {
    name = group.getName();
  }
  invariant(name, 'GroupName without a name');

  return <TextWithEntities text={name || ''} entities={TextEntities.parseEmoji(name || '')} />;
};

export default GroupName;
